/**
 * True when hostname is an AWS S3 endpoint (virtual-hosted or path-style).
 * Does not allow other *.amazonaws.com services or CloudFront aliases.
 */
export function isAwsS3Hostname(hostname) {
  if (!hostname || typeof hostname !== 'string') return false;

  const host = hostname.toLowerCase();

  return (
    /^(.+\.)?s3\.amazonaws\.com$/.test(host) ||
    /^(.+\.)?s3-[a-z0-9-]+\.amazonaws\.com$/.test(host) ||
    /^(.+\.)?s3\.[a-z0-9-]+\.amazonaws\.com$/.test(host) ||
    /^(.+\.)?s3\.dualstack\.[a-z0-9-]+\.amazonaws\.com$/.test(host) ||
    /^(.+\.)?s3-accelerate\.amazonaws\.com$/.test(host) ||
    /^(.+\.)?s3-accelerate\.dualstack\.amazonaws\.com$/.test(host)
  );
}

/**
 * Returns true when a document preview URL is safe to load in an iframe.
 * Allows only https S3 URLs without embedded credentials; blocks executable schemes.
 */
export function isSafeDocumentPreviewUrl(url) {
  if (!url || typeof url !== 'string') return false;

  try {
    const parsed = new URL(url.trim());
    if (parsed.protocol !== 'https:') return false;
    if (parsed.username || parsed.password) return false;
    return isAwsS3Hostname(parsed.hostname);
  } catch {
    return false;
  }
}
